<script setup lang="ts">
import type { OrderAddressFragment } from '#graphql-operations'

const props = defineProps<{
  width?: string | number
  height?: string | number
  address?: OrderAddressFragment
}>()

const runtimeConfig = useRuntimeConfig()

const addressQuery = computed(() => formatAddress(props.address ?? runtimeConfig.public.company))
const { locale } = useI18n()

const mapSrc = computed(() => {
  const url = new URL('https://maps.google.com/maps')
  url.searchParams.set('hl', locale.value) // language
  url.searchParams.set('q', `${addressQuery.value}+(${runtimeConfig.public.company.name})`) // address
  url.searchParams.set('t', 'm') // map type
  url.searchParams.set('z', '15') // zoom
  url.searchParams.set('iwloc', 'B') // info window location
  url.searchParams.set('output', 'embed') // output format

  return url.toString()
})
</script>

<template>
  <iframe
    allowfullscreen
    style="border:0"
    referrerpolicy="no-referrer-when-downgrade"
    :width="props.width ?? '100%'"
    :height="props.height ?? '100%'"
    :src="mapSrc"
    frameborder="0"
    scrolling="no"
    marginheight="0"
    marginwidth="0"
  />
</template>
